import { Auth, signInWithEmailAndPassword, onAuthStateChanged } from 'firebase/auth';
import { User } from '../../model/User';
import { IAuthService } from '../IAuthService';

export class AuthService implements IAuthService {
  private auth: Auth;

  constructor(auth: Auth) {
    this.auth = auth;
  }

  async login(email: string, password: string): Promise<User> {
    const result = await signInWithEmailAndPassword(this.auth, email, password);
    return { email: email, name: result.user.displayName };
  }

  async logout() {
    await this.auth.signOut();
  }

  onAuthStateChanged(callback: (user: User) => void): () => void {
    return onAuthStateChanged(this.auth, user => {
      console.log('user', user);
      callback(user ? { email: user.email, name: user.displayName } : null);
    })
  };
}